import { render, staticRenderFns } from "./contentDetail.vue?vue&type=template&id=ba76fb9e&scoped=true&"
import script from "./contentDetail.vue?vue&type=script&lang=js&"
export * from "./contentDetail.vue?vue&type=script&lang=js&"
import style0 from "./contentDetail.vue?vue&type=style&index=0&id=ba76fb9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba76fb9e",
  null
  
)

export default component.exports